import { GetFeatureFlagsAction } from 'actions/globalActions'
import { Reducer } from 'interfaces'
import { FeatureFlags } from 'interfaces/global'

const featureFlags: Reducer<FeatureFlags | null> = (prevState = null, action) => {
  switch (action.type) {
    case GetFeatureFlagsAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      return action.payload.response
    }
  }
  return prevState
}

export default featureFlags
